<template>
  <div class="container">
    <div class="grid justify-content-center">
      <div class="col-12 sm:col-8 md:col-4 comp-grid">
        <div class="card">
          <div class="">
            <div class="flex align-items-center">
              <div class="mr-2">
                <Avatar size="xlarge" class="primary" icon="pi pi-lock" />
              </div>
              <div>
                <div class="text-2xl font-bold text-blue-900">
                  Ghana Water Help Center
                </div>
                <div class="text-md font-medium">Password Reset</div>
              </div>
            </div>
          </div>
          <hr class="my-3" />
          <form ref="observer" tag="form" @submit.prevent="submitForm()">
            <div class="my-3">
              <Password
                class="w-full"
                inputClass="w-full"
                :feedback="true"
                toggleMask
                v-model="formData.password"
                placeholder="New Password"
                :class="getErrorClass('password')"
                ><template #header>
                  <h6>Create your new password</h6>
                </template>
                <template #content></template>
                <template #footer>
                  <Divider />
                  <p class="mt-2">Suggestions</p>
                  <ul class="pl-2 ml-2 mt-0" style="line-height: 1.5">
                    <li>At least one lowercase</li>
                    <li>At least one uppercase</li>
                    <li>At least one numeric value</li>
                    <li>Minimum 6 characters</li>
                  </ul>
                </template></Password
              >
              <small v-if="isFieldValid('password')" class="p-error">{{
                getFieldError("password")
              }}</small>
            </div>
            <div class="my-3">
              <Password
                class="w-full"
                inputClass="w-full"
                :feedback="false"
                toggleMask
                v-model="formData.confirm_password"
                placeholder="Confirm new password"
                :class="getErrorClass('confirm_password')"
              />
              <small v-if="isFieldValid('confirm_password')" class="p-error">{{
                getFieldError("confirm_password")
              }}</small>
            </div>
            <div class="text-center">
              <Button
                type="submit"
                class="w-full p-button-rounded py-3"
                :loading="saving"
                label="Change Password"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed, reactive, onMounted, toRefs } from "vue";
import { useRoute } from "vue-router";
import useVuelidate from "@vuelidate/core";
import { required, sameAs } from "@/services/validators";
import { useApp } from "@/composables/app.js";
import { useAddPage } from "@/composables/addpage.js";
import { $t } from "@/services/i18n";
const props = defineProps({
  pageName: {
    type: String,
    default: "auth",
  },
  routeName: {
    type: String,
    default: "resetpassword",
  },
  apiPath: {
    type: String,
    default: "auth/resetpassword",
  },
});
const app = useApp();
const route = useRoute();
const formDefaultValues = {
  password: "",
  confirm_password: "",
  token: route.query.token,
  email: route.query.email,
};
const formData = reactive({ ...formDefaultValues });
//form validation rules
const rules = computed(() => {
  return {
    password: { required },
    confirm_password: {
      required,
      sameAs: sameAs(formData.password, "Password"),
    },
  };
});
const v$ = useVuelidate(rules, formData); // form validation
const page = useAddPage({ props, formData, v$, beforeSubmit, afterSubmit });

function beforeSubmit() {
  return true;
}
// redirect to another page
function afterSubmit(response) {
  app.navigateTo("/index/resetpassword_completed");
}

const { submitted, saving } = toRefs(page.state);
//page methods
const { submitForm, getErrorClass, getFieldError, isFieldValid } = page.methods;
onMounted(() => {
  const pageTitle = "Reset Password";
  app.setPageTitle(props.routeName, pageTitle); // set browser page title
});
// expose page object for other components access
defineExpose({
  page,
});
</script>
